import app from "/src/app/app.module";
import moment from "moment";
app.controller('add-job-form', function ($scope, vxForms, $job, $depot, $locale, $auth, $api) {
    $scope.locale = $locale;
    $scope.jobFields = vxForms.jobs;
    $scope.busyStatus = null;

    $scope.options = {
        validation: {
            enabled: true
        },
        layout: {
            type: 'vertical',
            labelSize: 3,
            inputSize: 9
        }
    };

    $scope.today = function () {
        $scope.wizard.expirationDate = new Date();
    };
    $scope.today();


    $depot.getAllDepots(function (result) {
        $scope.wizard.allDepots = result;
    });

    $job.allKindOfParties(function (result) {
        $scope.wizard.kindofjobs = result;
    });

    $job.allJobStatuses(function (result) {
        $scope.wizard.jobstatuses = result;
    });

    $auth.getAllCompanies(function (result) {

        $scope.wizard.companies = result;
        if (result.length > 0) {
            $scope.wizard.selectedTendant = result[0];
        }
    }, true);
    
    // Handle prefill data from quote request
    if ($scope.wizard.prefillEventDate) {
        // Try to parse the event date (format: "2025-12-12" or similar)
        var parsedDate = moment($scope.wizard.prefillEventDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'D MMMM YYYY']);
        if (parsedDate.isValid()) {
            $scope.wizard.jobData = $scope.wizard.jobData || {};
            $scope.wizard.jobData.startdate = parsedDate.toDate();
            $scope.wizard.jobData.enddate = parsedDate.toDate();
        }
    }

    // Check busy status for a date
    $scope.checkBusyStatus = function (timestamp) {
        if (!timestamp) {
            $scope.busyStatus = null;
            return;
        }
        var date = moment(timestamp).format('YYYY-MM-DD');
        $api.get('v1/jobs/busy-check/' + date, function (result) {
            $scope.busyStatus = result;
        }, null, function () {
            $scope.busyStatus = null;
        });
    };

    $scope.$watch('wizard.jobData.startdate', function (newValue, oldValue) {
        if (!newValue)
            return;
        var date = moment(newValue);
        var newDate = date.hours(0).minutes(0).seconds(0);
        $scope.minDate = newDate.toDate();
        
        // Check busy status when date changes
        $scope.checkBusyStatus(newValue);
    });

});
